import { api } from '@/shared/api/api.ts'
import { getCookie, removeCookie } from '@/utilities/cookies.ts'
import { env } from '@/utilities/env.ts'
import { storage } from '@/utilities/storage.ts'

export async function logout(redirectHref: string, isHelpSeeker = false) {
	// 1.
	// Try to invalidate the user's session.
	const pathPrefix = isHelpSeeker ? 'online-users' : 'users'
	try {
		await api.request(`${pathPrefix}/revoke`, {
			method: 'post',
			json: {
				client_id: env.OAUTH_CLIENT_ID,
			},
		})
	} catch (error) {
		// Only log errors to the console instead of throwing so that the navigation below is still triggered.
		console.error(error)
	}

	// 2.
	// Remove the authentication cookies so that reloading the page in any way won't have a valid session anymore.

	removeCookie('access_token')
	removeCookie('refresh_token')

	// 3.
	// Clear Marker.io session.

	const cookies = getCookie()

	for (const cookie in cookies) {
		if (!cookie.startsWith('marker_id')) continue

		removeCookie(cookie)
	}

	storage.remove('mrkrui')
	storage.remove('mrkrui:custom-url-param')

	// 4.
	// Redirect to the login page.

	const loginUrl = new URL('/anmelden.html', window.location.origin)

	const currentUrlPath = redirectHref.replace(window.location.origin, '') || '/'
	if (currentUrlPath !== '/') {
		loginUrl.searchParams.set('seite', currentUrlPath)
	}

	window.location.assign(loginUrl)
}
